// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5.70013 4.4428L12 1.92285L18.2999 4.4428L17.5571 6.29975L17 6.07692V7.99988H23V21.9999H13V15H11V21.9999H1V7.99988H7V6.07692L6.44291 6.29975L5.70013 4.4428ZM3 19.9999H7V9.99988H3V19.9999ZM17 9.99988V19.9999H21V9.99988H17ZM13.0039 6.99805H11V9.00195H13.0039V6.99805Z"}}]};

const City14FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-14-filled',
    ref,
    icon: element,
  },
));

City14FilledIcon.displayName = 'City14FilledIcon';

export default City14FilledIcon;
